module.exports = __webpack_public_path__ + "9c3879ff4b2b758149b80171e18b0c5d.png";